import {useEnvConfig} from '@web-catalog/env';
import {useEffect, useState} from 'react';

import {ProfileType} from '@web-catalog/types';

import styles from './AuthController.module.scss';

type Props = {
  onSuccess: (profile: ProfileType) => void;
  onError: (errorMessage?: string) => void;
};

export default function IframeWrapper({onSuccess, onError}: Props) {
  const {AUTH_STATE, AUTH_UUID} = useEnvConfig();
  const [iframeUrl, setIframeUrl] = useState<string | null>(null);

  useEffect(() => {
    const callbackUrl = `${document.location.origin}/catalog/auth`;
    const queryParams = new URLSearchParams({
      act: 'autologin',
      redirect_uri: callbackUrl,
      state: AUTH_STATE,
      uuid: AUTH_UUID,
      app_id: '51903415',
    });
    setIframeUrl(`https://login.vk.com/?${queryParams}`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const messageListener = (e: MessageEvent) => {
      if (e.origin !== window.location.origin) {
        return;
      }
      const data = e.data;
      if (data?.source !== 'auth') {
        return;
      }
      if (data.errorMessage) {
        onError(data.errorMessage);
      } else {
        if (data.payload && data.payload.response) {
          onSuccess(data.payload.response);
        } else {
          onError('unexpected empty payload from iframe');
        }
      }
    };
    window.addEventListener('message', messageListener);
    return () => {
      window.removeEventListener('message', messageListener);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!iframeUrl) {
    return null;
  }

  return (
    <iframe
      src={iframeUrl}
      className={styles.authIframe}
      onLoad={(event) => {
        try {
          if (!event.currentTarget.contentDocument) {
            onError('failed to load iframe');
          }
        } catch (e) {
          console.warn(e);
        }
      }}
    />
  );
}
